export default {"src":"/_next/static/image/src/images/about/spinach-paw.67e918c5d1a9053a855a0fab301ef8ed.svg","height":46,"width":46};